import React from 'react';

import { useMatch } from 'react-router-dom';

import { RouterLink, RouterLinkProps } from '_lib/components/Link/RouterLink';

import { toSxArray } from '_lib/utils/helpers';

import { AppRoutePath, getFullAppRoutePath } from './nav.types';
import { NavigationItem, NavigationItemProps } from './NavigationItem';

type RouterNavigationItemProps = Pick<RouterLinkProps, 'sx'> & {
  routePath: AppRoutePath;
  icon: NavigationItemProps['icon'];
  isNavExpanded: NavigationItemProps['isNavExpanded'];
  text: NavigationItemProps['text'];
  setIsSlidingDrawerOpen: (value: boolean) => void;
};

export const RouterNavigationItem = (props: RouterNavigationItemProps) => {
  const { routePath, icon, isNavExpanded, text, sx, setIsSlidingDrawerOpen, ...restProps } = props;

  const isActiveMatch = useMatch(`${getFullAppRoutePath(routePath)}/*`);
  const isIdPathMatch = useMatch(`${getFullAppRoutePath(routePath)}/:id/*`);

  return (
    <RouterLink
      {...restProps}
      onClick={(e) => {
        if (isActiveMatch && !isIdPathMatch) e.preventDefault();
        // NOTE - 'Meta' is for macOS command key
        else if (!e.getModifierState('Control') && !e.getModifierState('Meta')) {
          setIsSlidingDrawerOpen(false);
        }
      }}
      reloadDocument={false}
      to={routePath}
      underline={'none'}
      sx={[{ color: 'inherit' }, ...toSxArray(sx)]}>
      <NavigationItem icon={icon} isNavExpanded={isNavExpanded} text={text} isActive={!!isActiveMatch} />
    </RouterLink>
  );
};
